import React from "react";
;
var ABS_TOOLTIP_ID = 'fe-abs-tooltip';
export var AbsTooltip = function (_a) {
    var title = _a.title, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.follow, follow = _d === void 0 ? false : _d, children = _a.children;
    var show = function (e) {
        var tooltip = document.getElementById(ABS_TOOLTIP_ID);
        if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.id = ABS_TOOLTIP_ID;
            tooltip.className = 'abs-tooltip';
            document.body.appendChild(tooltip);
        }
        className && tooltip.classList.add(className);
        placement && tooltip.classList.add(placement);
        tooltip.innerHTML = title;
        if (placement === 'top' || placement === 'bottom') {
            tooltip.style.top = (placement === 'bottom' ? e.pageY + 80 : e.pageY - 80) + "px";
            tooltip.style.left = e.pageX + 20 + "px";
        }
        else {
            tooltip.style.top = e.pageY + "px";
            tooltip.style.left = (placement === 'right' ? e.pageX + 150 : (e.pageX - tooltip.clientWidth) + 50) + "px";
        }
        tooltip.style.display = 'block';
    };
    var hide = function (e) {
        var tooltip = document.getElementById(ABS_TOOLTIP_ID);
        if (tooltip) {
            tooltip.style.display = 'none';
        }
    };
    var update = function (e) {
        var tooltip = document.getElementById(ABS_TOOLTIP_ID);
        if (tooltip && follow) {
            if (placement === 'top' || placement === 'bottom') {
                tooltip.style.top = (placement === 'bottom' ? e.pageY + 80 : e.pageY - 80) + "px";
                tooltip.style.left = e.pageX + 20 + "px";
            }
            else {
                tooltip.style.top = e.pageY + 35 + "px";
                tooltip.style.left = (placement === 'right' ? e.pageX + 150 : (e.pageX - tooltip.clientWidth) + 50) + "px";
            }
        }
    };
    return (React.createElement("span", { onMouseLeave: hide, onMouseEnter: show, onMouseMove: update }, children));
};
